import _ from 'underscore';

import {DigestAnalysis} from 'analyses/Analyses';
import * as biojs from 'BioJS';
import {Sequence as ComponentSequence} from 'components/Sequence';
import {PolymerTabState} from 'molbio/tabstates/PolymerTabState';
import {TabStateDefaults} from 'Navigation';

interface DigestTabStateDefaults extends TabStateDefaults {
  unsaved: boolean;
}

class DigestTabState extends PolymerTabState<ComponentSequence> {
  analysis!: DigestAnalysis;
  // @ts-expect-error: this shadows PolymerTabState.sequence().
  sequence!: ComponentSequence;
  _sequence!: biojs.Sequence;

  defaults(): DigestTabStateDefaults {
    return {
      ...super.defaults(),
      unsaved: true,
    };
  }

  initialize(attributes: {analysis: DigestAnalysis; sequence: ComponentSequence}, options: {}): void {
    // eslint-disable-next-line prefer-rest-params
    super.initialize(...arguments);
    this.analysis = attributes.analysis;
    this.sequence = attributes.sequence;
    this._sequence = attributes.sequence.get('_sequence');
    this.set('title', this.analysis.get('name'));
    this.set('id', `analysis_${this.analysis.cid}`);
    this.listenTo(this.analysis, 'change:name', (a: DigestAnalysis, title: string) => {
      this.set('title', title);
    });
    this.update();
    this.listenTo(this._sequence, 'change:bases change:circular', () => {
      this.update();
    });
  }

  update(): void {
    const enzymeIds = this.analysis.get('enzymes');
    const fragments = this.sequence.getFragments(enzymeIds);
    const oldFragments = this.analysis.get('fragments');
    if (oldFragments != null) {
      this.stopListening(oldFragments);
    }
    this.analysis.set('fragments', new biojs.SequenceCollection(fragments.sortBy((f) => f.get('start'))));
    this.listenTo(
      this.analysis.get('fragments'),
      'change:selected',
      // eslint-disable-next-line no-restricted-syntax
      _.bind(function () {
        // @ts-expect-error
        return this.trigger('selectedFragmentChange');
      }, this)
    );
  }
}

export default DigestTabState;
